module.exports = __webpack_public_path__ + "static/media/bg_8.5d14051e.jpg";